// string类型必输类型校验
export function stringRequired(value) {
    if (!value || !value.trim()) {
        return false;
    }
    return true;
}

// string类型正则表达式
export function stringRegExp(value, { regExp }) {
    return !regExp.test(value);
}

// object类型必输字段校验
export function objectRequiredField(obj, { fields = [] }) {
    if (!obj) {
        return false;
    }
    return fields.every(field => obj[field] != null && obj[field] !== "");
}

// object类型字段不等于
export function objectFieldNotEq(obj, { field = "", compare }) {
    if (!obj) {
        return false;
    }
    return obj[field] !== compare;
}

// values实际输入的值(一组值)，validators字段对应的校验器
export function checkRules(values, validators = {}) {
    const ruleFields = Object.keys(validators);
    const ret = {};
    ruleFields.forEach(field => {
        const rules = validators[field];
        ret[field] = checkRule(values[field], rules);
    });
    return ret;
}

// value实际输入的值（单个字段的值），rules对应的校验规则列表
export function checkRule(value, rules = []) {
    const ret = { message: "" };
    ret.isValid = rules.every(rule => {
        const isValid = rule.validator(value, rule);
        if (!isValid && rule.message) {
            ret.message = rule.message;
        }
        return isValid;
    });
    return ret;
}
